import React, { useEffect, useRef, useState } from 'react';
import { FlexBox } from '@make-software/cspr-design';
import { LoadingMediaPlaceholder } from './NftMediaPlaceholder';
import styled from 'styled-components';

const MediaWrapper = styled(FlexBox)(({ theme }) =>
  theme.withMedia({
    position: 'relative',
    '> video': {
      position: 'absolute',
      left: 0,
      top: 0,
      height: '100%',
      width: '100%',
    },
  })
);

interface NftPreviewMediaProps {
  url: string | undefined;
  mediaType: string;
  nftAlt?: string;
}

export const NftPreviewMedia = ({
  url,
  mediaType,
  nftAlt,
}: NftPreviewMediaProps) => {
  const [loading, setLoading] = useState(true);
  const mediaRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const handleLoad = () => {
      setLoading(false);
    };

    mediaRef.current &&
      mediaRef.current.addEventListener('loadedmetadata', handleLoad);

    return () => {
      mediaRef.current &&
        mediaRef.current.removeEventListener('loadedmetadata', handleLoad);
    };
  }, [mediaRef.current]);

  return (
    <MediaWrapper wrap={'wrap'} justify={'center'} align={'center'} grow={1}>
      {loading && <LoadingMediaPlaceholder />}
      {mediaType.includes('audio') ? (
        <audio controls src={url} ref={mediaRef} aria-label={nftAlt}>
          <source src={url} type={mediaType} />
          Your browser does not support the audio element.
        </audio>
      ) : (
        <video
          ref={mediaRef}
          src={url}
          width="100%"
          controls
          hidden={loading}
          aria-label={nftAlt}
        />
      )}
    </MediaWrapper>
  );
};
